export default __webpack_public_path__ + "static/media/3dkrender-footer.ccf91595.png";